<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <search-dsp-select v-model="tableParams.dspId" />
      <search-dsp-slot-select
        v-model="tableParams.dspSlotId"
        :dsp-id="tableParams.dspId"
        :slotIsEnable="false"
      />
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px" />
      <el-select
        v-model="tableParams.proType"
        filterable
        placeholder="占比类型"
      >
        <el-option
          v-for="item in proTypeList"
          :key="item.proType"
          :label="item.title"
          :value="item.proType"
        />
      </el-select>
      <emboss-button @click="toQuery" size="medium" color="#2C7A14">🔍</emboss-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px"
      >
        <el-button
          @click="
            downExcel(
              '/logBidResInfo/dsp/data/por/excel',
              '预算占比比例表',
              tableParams
            )
          "
          type="warning"
          size="small"
        >
          下载
        </el-button>
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"

        ref="report"
        row-key="id"
        lazy
        size="small"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          sortable
          :min-width="v.minWidth"
          :key="i"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import initTableMixin from "@/mixins/initTable";
import SearchDspSelect from "@/components/SearchDspSelect";
import SearchDspSlotSelect from "@/components/SearchDspSlotSelect";
import BaseDatePicker from "@/components/BaseDatePicker";
import EmbossButton from '@/components/EmbossButton';
import { downExcelMixin } from "@/mixins/downExcel";

export default {
  components: { SearchDspSelect, SearchDspSlotSelect, BaseDatePicker, EmbossButton },
  mixins: [initTableMixin, downExcelMixin],
  data() {
    return {
      checkColumns: [
        { field: "dspSlotName", title: "dsp广告位名称" },
        { field: "porType", title: "占比类型" },
        { field: "proPortion", title: "占比" },
        { field: "desc", title: "描述" },
      ],
      proTypeList: [
        { proType: 1, title: "标题" },
        { proType: 2, title: "域名" },
        { proType: 3, title: "均价" },
      ],
      tableParams: {
        proType: 1,
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    beforeInit() {
      this.tableUrl = "/logBidResInfo/dsp/data/por";
      this.tableParams.pageSize = undefined;
      this.tableParams.pageNum = undefined;
      return true;
    },
    afterInit(res) {
      this.tableData = res.data;
    },
    toQuery() {
      this.init();
    },
    changeDate(date) {
      this.tableParams.startTime = date.startTime;
      this.tableParams.endTime = date.endTime;
    },
  },
};
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 30px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.search-row {
  & > .el-select,
  & > .el-input {
    margin-right: 30px;
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: $--common-card-color;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}

::v-deep.el-table__placeholder {
  display: none;
}

::v-deep.el-table__expand-icon {
  width: auto !important;
}
</style>
